import React, { Component } from "react";
import "./Motivation.css";

class Motivation extends Component {
  findHomeMotivation = () => {
    const motivationText = [
      "Welcome to Outro, the pleasure is all mine. Let's begin.",
      "Welcome everybody! Kudos all around. Let's get started.",
      "It's a great day for a retro! Let's do this, shall we?",
      "I can see the hard work from here. Time to end on a high note!",
      "Welcome back, team. Are we ready to start?",
      "Are you feeling the burn? Relax, it's retro time.",
      "The time has come. Time for retro. Let's do this!",
      "Kudos to everyone for doing a retro today. Let's start!",
      "Y'all ready for this (retro)? Na na na. Let's go!",
      "Hello team, it's me Outro. Retro begins... now.",
      "Go team, it's your birthday, not really, retro anyway!",
    ];

    if (this.props.retroSessions) {
      const retrosCount = this.props.retroSessions.length;
      const modulo = retrosCount % 10;

      return motivationText[modulo];
    } else {
      return motivationText[0];
    }
  };

  findFinishedMotivation = () => {
    var motivation = "";
    const retrosCount = this.props.retroSessions.length;

    if (retrosCount === 1) {
      motivation =
        "Nice! You finished your very first Outro. How does it feel?";
    } else if (retrosCount === 2) {
      motivation = "Two Outros down, many more to go. Keep it up!";
    } else if (retrosCount === 3) {
      motivation = "Your 3rd Outro, huh? That’s awesome. Seriously.";
    } else if (retrosCount === 4) {
      motivation = "Congrats, team. That’s your 4th Outro. Way to go!";
    } else if (retrosCount >= 5 && retrosCount < 20) {
      motivation = `That’s your ${retrosCount}th Outro. It’s officially a habit. We did it!`;
    } else if (retrosCount >= 20) {
      motivation = `That makes ${retrosCount} completed Outros. Keep it up!`;
    }

    return motivation;
  };

  renderMotivation = type => {
    if (type === "home") {
      return this.findHomeMotivation();
    } else if (type === "finished") {
      return this.findFinishedMotivation();
    } else {
      return null;
    }
  };

  render() {
    return (
      <div className="motivation">{this.renderMotivation(this.props.type)}</div>
    );
  }
}

export default Motivation;



// WEBPACK FOOTER //
// ./src/components/Motivation.js